/**
 * Обёртка над localStorage / sessionStorage
 * Точный перенос из helpers/storage.js с типизацией.
 *
 * ВАЖНО: ключи с префиксом @connectone — совместимость со старым кабинетом.
 * Оба кабинета (старый и новый) используют один и тот же формат хранения,
 * поэтому если пользователь залогинен в одном — токен работает и в другом.
 */

const KEY_PREFIX = '@connectone';

function parseValue(value: string | null): any {
  if (value === null) return null;
  try {
    return JSON.parse(value) || value;
  } catch (_e) {
    return value;
  }
}

function formatValue(value: any): string {
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value);
}

function createStorageInterface(storageType: Storage) {
  return {
    get(key: string): any {
      try {
        return parseValue(storageType.getItem(`${KEY_PREFIX}/${key}`));
      } catch (_e) {
        return null;
      }
    },

    set(key: string, value: any): void {
      try {
        storageType.setItem(`${KEY_PREFIX}/${key}`, formatValue(value));
      } catch (_e) {
        // quota exceeded или private mode
      }
    },

    remove(key: string): void {
      try {
        storageType.removeItem(`${KEY_PREFIX}/${key}`);
      } catch (_e) {
        // noop
      }
    },
  };
}

export const storage = {
  local: createStorageInterface(localStorage),
  session: createStorageInterface(sessionStorage),
};
